module.exports = __webpack_public_path__ + "static/media/manizales.b982c9be.png";